<template>
  <div>
    <v-btn
      v-if="params.data?.estadoAcademico?.nombre"
      class="mb-2"
      x-small
      outlined
      :color="params.data?.estadoAcademico?.nombre == estadosAcademicos['Modular'] ? 'error' : undefined"
      @click="handleClick"
      :disabled="obteniendoInscripcion"
      :loading="obteniendoInscripcion">
      {{ params.data?.estadoAcademico?.nombre }}

      <v-icon small>mdi-information-outline</v-icon>
    </v-btn>

    <span v-else>-</span>

    <ModalHistorialesEstadosAcademicos
      ref="modalHistorialesEstadosAcademicosRef"
      :historialesEstadosAcademicos="inscripcion.historialesEstadosAcademicos" />
  </div>
</template>

<script>
import historialAcademicoMixin from '../mixins/historial-academico.mixin';

export default {
  name: 'Boton4HistorialEstadosAcademicos',
  mixins: [historialAcademicoMixin],
  methods: {
    handleClick() {
      const inscripcionId = this.params.data?.inscripcionId;

      if (inscripcionId) {
        this.obtenerInscripcionConHistorialEstadosAcademicos(inscripcionId);
      }
    },
  },
};
</script>